import React from "react";
import "./BoardSearchInput.scss";

const BoardSearchInput = ({
  value,
  onChange,
  placeholder = "Search cards...",
  className = "",
  id = "board-search",
}) => (
  <div className={`pb-search ${className}`.trim()}>
    <span className="pb-search__icon" aria-hidden="true">🔍</span>
    <input
      id={id}
      type="search"
      className="pb-search__input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  </div>
);

export default BoardSearchInput;
